import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router-dom';

import logo from 'assets/images/logo/logo_white.png';

const HeaderSub = ({ history, location }) => {
  const { pathname } = location;
  const [returnPath] = pathname.match(/\/(.*?)\/(.*?)\//g);
  return (
    <div className="header header-sub">
      <Nav pathname={pathname} />
      <nav>
        <ul>
          <button onClick={() => history.push(returnPath.substring(0, returnPath.length - 1))}>
            <FontAwesomeIcon icon={['fas', 'chevron-left']} /> Back
          </button>
          <img src={`/${logo}`} className="logo" alt="logo" />
        </ul>
      </nav>
    </div>
  );
};

export default withRouter(HeaderSub);
